export default __webpack_public_path__ + "static/media/Jenn-Thau-resume.9e9b48f9.pdf";